import { api } from "../../api_client";

export type InternalDeliveryCostSource = "manual" | "supplier_invoice" | "carrier_invoice" | "rate_card";

export interface UpsertInternalDeliveryCostPayload {
  orderType: string;
  orderId: number;
  actualCost: number;
  currency: string;
  costSource: InternalDeliveryCostSource | string;
  notes?: string;
}

export interface InternalDeliveryCostRecord {
  pickingId: number;
  orderType: string;
  orderId: number;
  actualCost: number;
  currency: string;
  costSource: string;
  notes?: string | null;
  recordedBy?: string | null;
  recordedAt: string;
}

const BASE = "/api/v1/admin/internal-delivery-rate-card";

export const internalDeliveryCostService = {
  upsertActualCost(pickingId: number, payload: UpsertInternalDeliveryCostPayload) {
    return api.put<InternalDeliveryCostRecord>(`${BASE}/costs/${pickingId}`, payload);
  },
};
